export default {"src":"/_next/static/media/icon-long-arrow.799b97b5.svg","height":5,"width":17,"blurWidth":0,"blurHeight":0};